import { FC, memo } from 'react';

import { ImageData } from '../VariationOne';
import { getWatermarkTag } from '../shared';
import UploadedImageRow from '../shared/UploadedImageRow';
import SettingsModal from './SettingsModal';

interface Props {
  image: ImageData;
  imageIndex: number;
  setImages: React.Dispatch<React.SetStateAction<ImageData[]>>;
  type: 'left' | 'right';
  settings?: boolean;
}

const NewUploadedImageRow: FC<Props> = ({
  image,
  imageIndex,
  setImages,
  type,
  settings,
}) => {
  const settingsApplied =
    image.divider !== 'none' ||
    image.brakes ||
    !image.quotes ||
    getWatermarkTag(image) !== 'none' ||
    image.textPosition !== 'bottom';

  return (
    <UploadedImageRow
      image={image}
      imageIndex={imageIndex}
      setImages={setImages as any}
      showSettings={settings}
      settingsApplied={settingsApplied}
      settingsModal={
        <SettingsModal
          image={image}
          imageIndex={imageIndex}
          setImages={setImages}
          type={type}
          onClose={() => {}}
        />
      }
    />
  );
};

export default memo(NewUploadedImageRow);
